import { Skeleton } from 'antd';
import React from 'react';

const MeetingCardSkeleton: React.FC = () => {
  return (
    <div className="mx-2 sm:mx-6 bg-white border border-slate-200 rounded-lg p-4 shadow-sm animate-pulse">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        {/* Title & Status */}
        <div className="flex items-start justify-between gap-3 mb-3 flex-1">
          <Skeleton.Input style={{ width: '60%' }} active size="default" />
          <Skeleton.Input style={{ width: 80 }} active size="small" />
        </div>

        {/* Time */}
        <div className="flex items-center text-sm text-slate-600 mb-3 bg-slate-50 rounded-lg p-2.5 border border-slate-100 w-full sm:w-auto">
          <div className="w-6 h-6 bg-slate-200 rounded-md mr-2.5" />
          <div className="flex-1">
            <Skeleton.Input style={{ width: 100 }} active size="small" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingCardSkeleton;
